export const TERMS_OF_SERVICE = `제1조 (목적)
본 약관은 DSiteSolution(이하 "회사")이 운영하는 웹사이트 및 회원 서비스(마이페이지, 견적·계약·프로젝트 조회 등)의 이용과 관련하여 회사와 회원 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (정의)
1. "서비스"란 회사가 제공하는 홈페이지, 회원 가입, 문의 접수, 견적·계약 확인, 프로젝트 진행 조회 등 일체의 온라인 서비스를 말합니다.
2. "회원"이란 본 약관에 동의하고 회사와 이용계약을 체결한 자를 말합니다.
3. "아이디(ID)"란 회원 식별과 서비스 이용을 위해 회원이 설정하고 회사가 승인한 이메일 주소를 말합니다.

제3조 (약관의 게시와 개정)
1. 회사는 본 약관의 내용을 서비스 초기 화면 또는 연결 화면에 게시합니다.
2. 회사는 관련 법령을 위반하지 않는 범위에서 본 약관을 개정할 수 있으며, 개정 시 적용일자 및 개정 사유를 사전 공지합니다.
3. 회원이 개정 약관에 동의하지 않는 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.

제4조 (회원가입)
1. 이용자는 회사가 정한 가입 양식에 따라 정보를 기입하고 본 약관 및 개인정보 처리방침에 동의함으로써 회원가입을 신청합니다.
2. 회사는 다음 각 호에 해당하지 않는 한 가입을 승낙합니다.
  ① 타인의 정보를 도용한 경우
  ② 허위 정보를 기재한 경우
  ③ 기타 회사가 정한 이용신청 요건을 충족하지 못한 경우
3. 회원은 가입 정보에 변경이 있는 경우 즉시 수정해야 합니다.

제5조 (서비스의 제공)
1. 회사는 회원에게 다음 서비스를 제공합니다.
  ① 프로젝트·견적·계약 관련 정보 열람
  ② 문의 및 상담 내역 확인
  ③ 회사가 추가로 정하는 부가 서비스
2. 서비스는 연중무휴 1일 24시간 제공을 원칙으로 하나, 시스템 점검 등 필요한 경우 일시 중단될 수 있습니다.

제6조 (회원의 의무)
회원은 다음 행위를 하여서는 안 됩니다.
1. 타인의 정보 도용
2. 회사 및 제3자의 지식재산권 침해
3. 서비스 운영을 방해하는 행위
4. 법령 및 공서양속에 반하는 행위

제7조 (회원 탈퇴 및 자격 상실)
1. 회원은 언제든지 마이페이지 등 회사가 정한 방법으로 탈퇴를 요청할 수 있습니다.
2. 회사는 회원이 본 약관을 위반한 경우 사전 통지 후 이용계약을 해지할 수 있습니다.

제8조 (면책)
1. 회사는 천재지변, 불가항력, 회원의 귀책사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.
2. 회사는 회원 상호 간 또는 회원과 제3자 간 분쟁에 개입하지 않으며 이로 인한 손해에 대해 책임을 지지 않습니다.

제9조 (준거법 및 관할)
본 약관은 대한민국 법령에 따르며, 분쟁 발생 시 회사 본점 소재지를 관할하는 법원을 전속 관할로 합니다.

부칙
본 약관은 2025년 6월 3일부터 시행합니다.`;

export const PRIVACY_POLICY = `DSiteSolution(이하 "회사")는 「개인정보 보호법」 등 관련 법령을 준수하며, 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.

1. 개인정보의 처리 목적
회사는 다음 목적을 위해 개인정보를 처리합니다.
- 회원 가입 및 관리: 본인 확인, 회원 식별, 부정 이용 방지, 고지·통지
- 서비스 제공: 견적·계약·프로젝트 관련 정보 제공, 문의 응대
- 고객 상담 및 민원 처리: 문의 확인, 사실조사, 처리 결과 통보

2. 처리하는 개인정보 항목
- 필수: 이름, 이메일, 비밀번호(암호화 저장)
- 선택: 회사명, 연락처
- 자동 수집: 서비스 이용 기록, 접속 IP, 쿠키(해당 시)

3. 개인정보의 처리 및 보유 기간
① 회원 정보: 회원 탈퇴 시까지. 단, 관련 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관합니다.
  - 계약·청약 철회 기록: 5년 (전자상거래법)
  - 소비자 불만·분쟁 처리 기록: 3년 (전자상거래법)
  - 접속 로그: 3개월 (통신비밀보호법)

4. 개인정보의 제3자 제공
회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 이용자의 동의가 있거나 법령에 근거한 경우에 한해 제공할 수 있습니다.

5. 개인정보 처리의 위탁
회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리 업무를 위탁할 수 있습니다.
- 이메일 발송: SMTP/메일 서비스 제공업체
- 호스팅·DB: 클라우드/서버 호스팅 사업자
위탁 시 개인정보가 안전하게 관리되도록 계약 등 필요한 조치를 취합니다.

6. 정보주체의 권리·의무 및 행사 방법
이용자는 언제든지 다음 권리를 행사할 수 있습니다.
- 개인정보 열람, 정정, 삭제, 처리정지 요청
- 회원 탈퇴(동의 철회)
권리 행사는 이메일(dsitesolution@dsitesolution.com) 또는 마이페이지를 통해 가능합니다.

7. 개인정보의 파기
회사는 개인정보 보유기간 경과 또는 처리 목적 달성 시 지체 없이 해당 정보를 파기합니다.
- 전자적 파일: 복구 불가능한 방법으로 영구 삭제
- 출력물: 분쇄 또는 소각

8. 개인정보의 안전성 확보 조치
회사는 개인정보 보호를 위해 접근 권한 관리, 비밀번호 암호화, 접속 기록 보관, 보안 프로그램 적용 등 필요한 기술·관리적 조치를 시행합니다.

9. 개인정보 보호책임자
- 담당: DSiteSolution 개인정보보호 담당
- 이메일: dsitesolution@dsitesolution.com

10. 개인정보 처리방침 변경
본 방침의 내용 추가·삭제·수정이 있을 경우 시행 7일 전부터 웹사이트 공지사항을 통해 고지합니다.

시행일: 2025년 6월 3일`;
